import { useQuery } from "react-query";
import { AllLokasiResponse } from "../../../../models/Job";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const fetchAllLokasiKey = "all-lokasi-key";

export async function fetchAllLokasi(): Promise<AllLokasiResponse[]> {
  const res = await ApiClient.get(`/AllLokasi`);
  return res.data;
}

export default function useFetchAllLokasi() {
  return useQuery([fetchAllLokasiKey], queryWrapper(fetchAllLokasi));
}
